<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="420">
    <v-card>
        <v-toolbar class="mid-font" dense elevation="1" >
            <v-icon left >mdi-account-box</v-icon><span class="va-underline">{{state=='new'?'New':'Edit'}} Service Bay</span>
            <v-spacer/>
            <v-icon  @click="emitToParent('close')">mdi-close</v-icon>
          </v-toolbar>
        <v-card-text>
             <v-form
                ref="form"
                class="mt-4"
                v-model="valid"
                lazy-validation
              >
              <v-row>
                <v-col cols="12">
                      <v-text-field
                 outlined
                  dense
                 v-model="item.name"
                  label="Name"
                  :rules="textRules"
                required
                ></v-text-field>
               <v-textarea
                 v-model="item.description"
                 rows="2"
                  label="Description"
                  outlined
                  dense
                required
                ></v-textarea>
                 
                <!-- <v-autocomplete
                  v-model="item.status"
                   :rules="textRules"
                required
                  :items="['Active', 'Inactive']"
                  outlined
                    dense
                  label="Status  "
                  ></v-autocomplete>  -->
                </v-col>
              </v-row>
             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    data: {
       type: Object,
        default: ()=>{}
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      newpassword:'',
      show1: false,
      item: {},
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      },
      ROLES() {
        return ['New Application', 'Verified', "Closed"]
      }
  },
  watch: {
    show (v) {
      if (v) {
        this.item = {}
         if(this.state != 'new') {
              this.item=this.data
          }
      } 
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
            this.state=='new'?this.Add():this.Update()
        }
      },
       Add: function() {
        this.$http.post("new_service_bay", this.item).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          if(response.data.status){
              this.emitToParent("close")
          }
        }).catch(e => {
          console.log(e.data)
        })
     },
      Update: function() {
       
       this.$http.post("update_service_bay", this.item).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          if(response.data.status){
              this.emitToParent("close")
          }
        }).catch(e => {
          console.log(e.data)
        })
     },
   
    emitToParent () {
        this.$emit('DialogEvent', "")
    }
  }
}
</script>
